import { useResellerMutation, useResellerQuery } from '@features/redux/apis/org';
import { useAlert } from '@hooks/useAlert';
import { MutationEffect } from '@helpers/MutationEffect';
import { Operation } from '@/types/general';
import { useQuery } from '@hooks/useQuery';
import { QueryEffect } from '@helpers/QueryEffect';

export const ResellerEffects = () => {
    const resellerId = useQuery().get('id');
    const operation = resellerId ? Operation.Edit : Operation.Create;

    const queryState = useResellerQuery({ resellerId: +resellerId! }, { skip: operation === Operation.Create });

    const [, mutationState] = useResellerMutation({
        fixedCacheKey: operation === Operation.Edit ? 'ResellerMutation' : 'ResellerCreation',
    });

    const { setAlert } = useAlert();

    return (
        <>
            <MutationEffect
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-expect-error
                mutationState={mutationState}
                effects={{
                    isError: () => {
                        setAlert(`Failed to ${operation} Reseller`, 'error');
                        mutationState.reset();
                    },
                    isSuccess: () => {
                        setAlert('Reseller Saved.', 'success');
                        mutationState.reset();
                    },
                }}
            />

            <QueryEffect
                queryState={queryState}
                effects={{
                    isError: () => {
                        setAlert('Failed to Load Reseller Data', 'error');
                    },
                }}
            />
        </>
    );
};
